import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 付款管理定义
 */
class AmountType extends UltMeta {
    PAYMENT = new Meta(1, "付款");
    REFUND = new Meta(2, "退款");
}
export const REVENUE_AMOUNT_TYPE = new AmountType();

/**
 * 付款管理定义
 */
class RevenueRateType extends UltMeta {
    DAY = new Meta(1, "按日结算");
    MONTH = new Meta(2, "按月结算");
}
export const REVENUE_RATE_TYPE = new RevenueRateType();
class RevenueRateDays extends UltMeta {
    DAY = new Meta(1, "天");
    MONTH = new Meta(2, "月");
}
export const REVENUE_RATE_DAYS = new RevenueRateDays();

class RevenueRateTypeOptions extends UltMeta {
    DAY = new Meta(1, "按日结算（年化收益率÷360）");
    MONTH = new Meta(2, "按月结算（年化收益率÷12)");
}
export const REVENUE_RATE_TYPE_OPTION = new RevenueRateTypeOptions();
